import React from 'react';
import ScheduleSendOutlined from '@mui/icons-material/ScheduleSendOutlined';
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import StatCard from '../StatCard'

const CardObrasAindaNaoReceberamOrcamento = (props) => {
  const obrasAindaSemOrcamento = useSelector((state) => state.dashboard?.dashboard?.obrasAindaSemOrcamento)

  return (
    <StatCard
      {...props}
      label="Obras ainda sem propostas"
      value={obrasAindaSemOrcamento ? obrasAindaSemOrcamento : 0}
      icon={<ScheduleSendOutlined />}
    />
  );
}

CardObrasAindaNaoReceberamOrcamento.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
}

export default CardObrasAindaNaoReceberamOrcamento
